import React from 'react';

const ArrowNarrowDownLeftIcon: React.FC = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 5L5.5 15M5.5 15H12.1667M5.5 15V8.33333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowNarrowDownLeftIcon;
